import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FeedbackMessageComponent } from '../../components/feedback-message/feedback-message.component';
@Component({
  selector: 'app-coming-soon',
  imports: [CommonModule, FeedbackMessageComponent],
  templateUrl: './coming-soon.component.html',
  styleUrl: './coming-soon.component.scss',
})
export class ComingSoonComponent {}
